import { GraphQLGroupRecommendationsRequester } from '@cobliteam/api-lib';
import { useEffect } from 'react';
import useUser from '../useEntity/useUser';
import useFeatureFlags from '../useFeatureFlags';

const requester = new GraphQLGroupRecommendationsRequester();

// Uma frota registrada é registrada para sempre; repetir a cada montagem só gera escrita à toa.
// Fora do hook porque o Set precisa sobreviver à desmontagem ao trocar de página.
const registeredFleetIds = new Set<string>();

/** Só para teste: o Set vive no módulo e vazaria entre casos. */
export const resetRegisteredFleetsForTest = () => registeredFleetIds.clear();

/**
 * Avisa a user-api que a frota usa a feature de recomendações, para o job agendado saber quem
 * visitar. Não gera nada e não bloqueia a renderização — o retorno é ignorado de propósito.
 */
const useRegisterFleetRecommendations = (enabled = true) => {
  const { getSession } = useUser();
  const fleetId = getSession()?.fleet?.id;
  const { recommendationsRegisterFleet } = useFeatureFlags();

  useEffect(() => {
    if (!(enabled && recommendationsRegisterFleet && fleetId)) return;
    if (registeredFleetIds.has(fleetId)) return;

    registeredFleetIds.add(fleetId);
    // Falhar aqui não pode tirar as recomendações da tela: o registro é para o próximo tick do
    // job, e a leitura da página não depende dele.
    requester.touchFleetRecommendations(fleetId).catch(() => registeredFleetIds.delete(fleetId));
  }, [enabled, recommendationsRegisterFleet, fleetId]);
};

export default useRegisterFleetRecommendations;
